import React from "react";

function TabellaAcquaFitNuova() {
    return(
        <div className="table-container">
            <table className="table text-center m-auto" style={{maxWidth: "40em"}}>
                <tbody>
                <tr>
                    <td className="data-cell"></td>
                    <td className="data-cell" style={{fontFamily: "Hammersmith One", fontSize: "22px"}} colSpan={2}>Mattino</td>
                    <td className="data-cell"></td>
                </tr>
                <tr>
                    <th className="" scope="col">Lun</th>
                    <th className="" scope="col">Mer</th>
                    <th className="" scope="col">Gio</th>
                    <th className="" scope="col">Sab</th>
                </tr>
                <tr>
                    <td className="data-cell">
                        9:15 - 10:00 <br/> <a href="#infoAcquaFitness" style={{color: "black"}}>Acqua Fitness</a>
                    </td>
                    <td className="data-cell">
                        9:15 - 10:00 <br/> <a href="#infoAcquaFitness" style={{color: "black"}}>Soft Water Gag</a>
                    </td>
                    <td className="data-cell">
                        9:15 - 10:00 <br/> <a href="#infoAcquaFitness" style={{color: "black"}}>Acqua Fitness</a>
                    </td>
                    <td className="data-cell"></td>
                </tr>
                <tr>
                    <td className="data-cell">
                        10:00 - 10:45 <br/> <a href="#infoAcquaFitness" style={{color: "black"}}>Acqua Fitness</a>
                    </td>
                    <td className="data-cell"></td>
                    <td className="data-cell">
                        10:00 -10:45 <br/> <a href="#infoAcquaFitness" style={{color: "black"}}>Acqua Fitness</a>
                    </td>
                    <td className="data-cell">
                        10:15 - 11:00 <br/> <a href="#infoAcquaFitness" style={{color: "black"}}>Deep Water</a>
                    </td>
                </tr>
                <tr>
                    <td className="data-cell"></td>
                    <td className="data-cell"></td>
                    <td className="data-cell"></td>
                    <td className="data-cell">
                        11:00 - 11:45 <br/> <a href="#infoAcquaFitness" style={{color: "black"}}>Deep Water</a>
                    </td>
                </tr>
                </tbody>
            </table>
            <table className="table text-center m-auto" style={{maxWidth: "40em"}}>
                <tbody>
                <tr>
                    <td className="data-cell"></td>
                    <td className="data-cell" style={{fontFamily: "Hammersmith One", fontSize: "22px"}} colSpan={1}>Intervallo</td>
                    <td className="data-cell"></td>
                </tr>
                <tr>
                    <th className="" scope="col">Lun</th>
                    <th className="" scope="col">Mer</th>
                    <th className="" scope="col">Gio</th>
                </tr>
                <tr>
                    <td className="data-cell">
                        12:40 - 13:25 <br/> <a href="#infoAcquaFitness" style={{color: "black"}}>Acqua Fitness</a>
                    </td>
                    <td className="data-cell">
                        12:30 - 13:30 <br/> <a href="#infoAcquaFitness" style={{color: "black"}}>Acqua Triathlon</a>
                    </td>
                    <td className="data-cell">
                        12:40 - 13:25 <br/> <a href="#infoAcquaFitness" style={{color: "black"}}>Acqua Fitness</a>
                    </td>
                </tr>
                <tr>
                    <td className="data-cell">
                        13:30 - 14:15 <br/> <a href="#infoAcquaFitness" style={{color: "black"}}>Acqua Fitness</a>
                    </td>
                    <td className="data-cell">
                        13:30 - 14:30 <br/> <a href="#infoAcquaFitness" style={{color: "black"}}>Acqua Triathlon</a>
                    </td>
                    <td className="data-cell">
                        13:30 - 14:15 <br/> <a href="#infoAcquaFitness" style={{color: "black"}}>Acqua Fitness</a>
                    </td>
                </tr>

                </tbody>
            </table>
            <table className="table text-center m-auto" style={{maxWidth: "40em"}}>
                <tbody>
                <tr>
                    <td className="data-cell" style={{fontFamily: "Hammersmith One", fontSize: "22px"}} colSpan={1}>Sera</td>
                </tr>
                <tr>
                    <th className="" scope="col">Mer</th>
                </tr>
                <tr>
                    <td className="data-cell">
                        19:15 - 20:00 <br/> <a href="#infoAcquaFitness" style={{color: "black"}}>Acqua Fitness</a>
                    </td>
                </tr>
                <tr>
                    <td className="data-cell">
                        20:00 - 20:45 <br/> <a href="#infoAcquaFitness" style={{color: "black"}}>Acqua Fitness</a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    )
}

export default TabellaAcquaFitNuova